const initState = {
    app: [],
    
    
  };
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default (state = initState, action) => {
    switch (action.type) {
      
      case "APPDATA": {
        return {...state, app:action?.payload }
      }    
      case "UPDATE_APP_TOKEN": {
        return {...state, RecentAppToken:action?.payload }
      }  
      case "CURSOR": {
        return {...state, cursorHover:action?.payload }
      }  case "LoginSignUpPopUp": {
        return {...state, loginSignUpPopUp:action?.payload }
      }
      case "pageTitle": {
        return {...state, pageTitle:action?.payload }
      } 
      case "testTitle": {
        return {...state, testTitle:action?.payload }
      } 
      case "testImage": {
        return {...state, testImage:action?.payload }
      }
      case "pageDescription": {
        return {...state, pageDescription:action?.payload }
      }
      case "pageSEO": {
        return {...state, pageSEO:action?.payload }
      }
      
      
      
      case "CURSORTEXT": {
        return {...state, cursorHoverText:action?.payload }
      }case "CURSORTEXTBG": {
        return {...state, cursorHoverTextBg:action?.payload }
      }  case "CURSORTEXTCOLOR": {
        return {...state, cursorHoverTextColor:action?.payload }
      }  case "CURSORTEXTDIRECTION": {
        return {...state, textDirection:action?.payload }
      }  case "MAINMENU": {
        return {...state, mainMenuStatus:action?.payload }
      }  
      
      case "LOGOUT": {
  
        localStorage.clear()
        return {...state, app:null,RecentAppToken:null ,CurrentPostId:null,crmPass:null }
         
          
        
      }
  
      
      default: {
        return state;
      }
    }
  };
  
  
  